'use strict';

import React, { Component } from 'react'

import Layout from '@Layout/BackOffice'

import ModelPicker from '@/Form/V2/ModelPicker'
import Select      from '@/Form/V2/Select'

import SearchBarV2 from '@/Lists/SearchBarV2'
import Dashboard   from '@/Lists/Dashboard'
import UserRow     from '@/Lists/Rows/UserRow'

import config from '@Config/EC/EC_member'

import { roles, user_status } from '@Config/options'

import Link from '@Pure/Link'

let app = window.app;

const roles_options =
[
	{ label: 'Tous', value: 'all' }
]
.concat(roles);

const status_options =
[
	{ label: 'Tous les statuts', value: 'all' }
]
.concat(user_status);

const sortable_columns =
[
	'email', 'firstname', 'lastname', 'createdAt', 'validation_date'
];

const header = Object.keys(config.header_map).map(function (label)
{
	const name = config.header_map[label];

	const item =
	{
		label: label,
		name: name,
		sortable: sortable_columns.includes(name)
	};

	return item;
});

const fields = header.map(data => data.name);

const fields_with_timeout = ['email', 'firstname', 'lastname'];

export default class UsersDashboardPage extends Component
{
	state =
	{
		email: window.localStorage.getItem('UsersList.email') || '',

		delayed_email: window.localStorage
		.getItem('UsersList.email') || '',

		firstname: window.localStorage.getItem('UsersList.firstname') || '',

		delayed_firstname: window.localStorage
		.getItem('UsersList.firstname') || '',

		lastname: window.localStorage.getItem('UsersList.lastname') || '',

		delayed_lastname: window.localStorage
		.getItem('UsersList.lastname') || '',

		EC_id: window.localStorage.getItem('UsersList.EC_id') || '',

		permissions: window.localStorage.getItem('UsersList.permissions') || '',

		status: window.localStorage.getItem('UsersList.status') || '',

		status_messages: { }
	};

	UNSAFE_componentWillMount ()
	{
		app.resetFunctions();
	}

	handleSearchChange = (value, data={ }, e) =>
	{
		const component = this, props = this.props, state = this.state;

		component.handleChange({ value: value, name: data?.name, e });
	}

	handleSelectChange = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		component.handleChange({ value: e.target.value, name: e.target.name, e });
	}

	handleChange = ({ value, name, e }) =>
	{
		const component = this, props = this.props, state = this.state;

	// Prevent on mount trigger
		if (e === null && fields_with_timeout.includes(name)) return;

		window.localStorage.setItem('UsersList.' + name, value || '');

		component.setState({ [name]: value || '' });

		if (fields_with_timeout.includes(name) === false) return;

		if (component.search_timeout)
		{
			window.clearTimeout(component.search_timeout);
		}

		component.search_timeout = window.setTimeout(function ()
		{
			component.search_timeout = undefined;

			component.setState({ ['delayed_' + name]: value || '' });
		},
		320);
	}

	handleFilterChange = (value, e, name) =>
	{
		const component = this, props = this.props, state = this.state;

		component.handleChange.bind(this)({ value: value, name: name, e: e });
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const filters =
		{
			email: state.delayed_email,
			lastname: state.delayed_lastname,
			firstname: state.delayed_firstname,
			EC_id: state.EC_id,

			permissions: state.permissions,
			status: state.status
		};

		var output =
		(
			<Layout history={ props.history } page_title="Liste des utilisateurs">

				<div className="page-content">

					<div className="c-dashboard-filters">

						<SearchBarV2 name="email" value={ state.email }
							onChange={ component.handleChange }
							label="Email"
						/>

						<SearchBarV2 name="firstname" value={ state.firstname }
							onChange={ component.handleChange }
							label="Prénom"
						/>

						<SearchBarV2 name="lastname" value={ state.lastname }
							onChange={ component.handleChange }
							label="Nom"
						/>

						<ModelPicker onChange={ component.handleChange }
							name="EC_id"
							value={ state.EC_id }
							label="Sélection d'un CSE"
							model="enterprisecomitee"
							url="/autocomplete/ECs"
							bemit={ ['25%'] }
							resetable
						/>

						<Select name="permissions" value={ state.permissions }
							onChange={ component.handleSelectChange }
							label="Type d'utilisateur"
							options={ roles_options }
							bemit={ ['user-type'] }
						/>

						<Select name="status" value={ state.status }
							onChange={ component.handleSelectChange }
							label="Statut"
							options={ status_options }
							bemit={ ['user-status'] }
						/>

					</div>

					<div className="u-flex u-content-end u-margin-bottom-20">
						<Link href="/gestion-des-CE/nouveau-membre"
							className="c-btn c-btn--add u-no-margin-top">
							Nouvel utilisateur
						</Link>
					</div>

					<div className="o-content">
						<Dashboard model="User" items-per-page={ 60 }
							url="/dashboard/users" filters={ filters }
							header={ header } fields={ fields }
							order="asc" order-by="$natural"
							disable-sort={ filters.searched || filters.searched_EC
								? true : false }
							component={ UserRow }
						/>
					</div>

				</div> { /* /page-content */ }

			</Layout>
		);

		return output;
	}
}
